"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FieldMessage = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var component_library_1 = require("@kaizen/component-library");
var caution_white_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/caution-white.icon.svg"));
var exclamation_white_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/exclamation-white.icon.svg"));
var typography_1 = require("@kaizen/typography");
var FieldMessage_module_scss_1 = __importDefault(require("./FieldMessage.module.scss"));
var FieldMessage = function (_a) {
    var message = _a.message, _b = _a.status, status = _b === void 0 ? "default" : _b, _c = _a.position, position = _c === void 0 ? "bottom" : _c, _d = _a.reversed, reversed = _d === void 0 ? false : _d, classNameOverride = _a.classNameOverride, automationId = _a.automationId, restProps = __rest(_a, ["message", "status", "position", "reversed", "classNameOverride", "automationId"]);
    var textColor = status === "default"
        ? reversed
            ? "white-reduced-opacity"
            : "dark-reduced-opacity"
        : "dark";
    return (react_1["default"].createElement("div", __assign({ "data-automation-id": automationId, className: (0, classnames_1["default"])(FieldMessage_module_scss_1["default"].message, FieldMessage_module_scss_1["default"][status], classNameOverride, reversed && FieldMessage_module_scss_1["default"].reversed, position === "bottom" && FieldMessage_module_scss_1["default"].positionBottom, position === "top" && FieldMessage_module_scss_1["default"].positionTop) }, restProps),
        (status === "error" || status === "caution") && (react_1["default"].createElement("span", { className: FieldMessage_module_scss_1["default"].warningIcon },
            react_1["default"].createElement(component_library_1.Icon, { icon: status === "error" ? exclamation_white_icon_svg_1["default"] : caution_white_icon_svg_1["default"], title: "".concat(status, " message"), role: "img", inheritSize: false }))),
        react_1["default"].createElement("div", { className: FieldMessage_module_scss_1["default"].message },
            react_1["default"].createElement(typography_1.Paragraph, { tag: typeof message === "string" ? "p" : "div", variant: "small", color: textColor }, message))));
};
exports.FieldMessage = FieldMessage;
exports.FieldMessage.displayName = "FieldMessage";
//# sourceMappingURL=FieldMessage.js.map